import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaburhireinmaval() {



    const cardData =
    {
        keyword: 'Urbania Bus Hire in Maval',
        heading: 'Urbania on rent in pune: Urbania Bus Hire in Maval',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Bus Hire in Maval for corporate groups, families, tourists, and event travelers planning group travel to and from Maval. Our well-maintained Force Urbania bus fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance trips, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Maval. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire in Maval.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Urbania Bus Hire in Maval",
      "description": "Urbania Bus Hire in Maval offers fully air-conditioned Urbania buses for comfortable city travel, corporate trips, family outings, and social events. Professional chauffeurs and well-maintained vehicles ensure a safe, smooth, and enjoyable journey."
    },
    {
      "name": "Maval Urbania on Rent",
      "description": "Maval Urbania on Rent provides reliable and spacious Urbania vehicles suitable for group travel, sightseeing, and corporate tours. Air-conditioned interiors and trained drivers ensure comfort, safety, and punctuality for every trip."
    },
    {
      "name": "Urbania Rental Service Maval Pune",
      "description": "Urbania Rental Service Maval Pune offers premium Urbania vehicles for family outings, corporate travel, and special events. Emphasis on well-maintained buses and professional chauffeur services ensures a hassle-free travel experience."
    },
    {
      "name": "Urbania AC Bus Hire Maval",
      "description": "Urbania AC Bus Hire Maval provides fully air-conditioned buses ideal for long-distance travel, group tours, corporate events, and leisure trips. Spacious seating and professional drivers make every journey comfortable and safe."
    },
    {
      "name": "Corporate Urbania Hire Maval",
      "description": "Corporate Urbania Hire Maval specializes in office trips, employee transportation, and corporate travel solutions. Reliable and punctual service with trained chauffeurs ensures a professional and smooth commuting experience."
    },
    {
      "name": "Urbania for Outstation Maval Pune",
      "description": "Urbania for Outstation Maval Pune offers safe and comfortable long-distance travel. Fully air-conditioned vehicles with experienced drivers provide smooth journeys to nearby cities, tourist destinations, and business locations."
    },
    {
      "name": "Urbania Airport Transfer Maval",
      "description": "Urbania Airport Transfer Maval provides timely and hassle-free airport pickups and drops. Spacious vehicles with professional chauffeurs ensure convenient, safe, and comfortable travel to and from Pune Airport."
    },
    {
      "name": "Luxury Urbania Maval",
      "description": "Luxury Urbania Maval offers high-end, fully air-conditioned vehicles with plush interiors for VIP travel, weddings, and executive trips. Professional chauffeurs ensure a premium travel experience with comfort, style, and safety."
    },
    {
      "name": "Affordable Urbania Hire Maval",
      "description": "Affordable Urbania Hire Maval provides cost-effective Urbania rental solutions without compromising on comfort or service quality. Ideal for families, groups, and corporate clients seeking value-for-money transportation."
    },
    {
      "name": "Chauffeur Driven Urbania Maval",
      "description": "Chauffeur Driven Urbania Maval ensures stress-free travel with trained and verified drivers. Fully air-conditioned vehicles and courteous service guarantee smooth and safe journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Maval",
      "description": "Urbania for Wedding Events Maval offers elegant and comfortable vehicles for weddings, guests, and family members. Air-conditioned buses with professional chauffeurs ensure stylish and hassle-free wedding transportation."
    },
    {
      "name": "Urbania for Office Trips Maval",
      "description": "Urbania for Office Trips Maval provides reliable and comfortable transportation for daily office commutes, team outings, and corporate events. Focused on punctuality and comfort, it ensures smooth travel for employees and teams."
    },
    {
      "name": "Best Urbania Rental Maval Pune",
      "description": "Best Urbania Rental Maval Pune delivers top-rated Urbania rental services known for vehicle quality, reliability, and customer satisfaction. Perfect for corporate, family, and group travel requiring premium and hassle-free transport."
    },
    {
      "name": "Urbania Group Travel Maval",
      "description": "Urbania Group Travel Maval provides organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned vehicles with professional chauffeurs guarantee a safe and enjoyable group travel experience."
    },
    {
      "name": "Reliable Urbania Hire Maval Pune",
      "description": "Reliable Urbania Hire Maval Pune ensures trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs provide a convenient, comfortable, and reliable travel experience for all passengers."
    }
  ],
  "tableData": [
    ["Urbania Bus Hire in Maval", "Maval Urbania on Rent"],
    ["Urbania Rental Service Maval Pune", "Urbania AC Bus Hire Maval"],
    ["Corporate Urbania Hire Maval", "Urbania for Outstation Maval Pune"],
    ["Urbania Airport Transfer Maval", "Luxury Urbania Maval"],
    ["Affordable Urbania Hire Maval", "Chauffeur Driven Urbania Maval"],
    ["Urbania for Wedding Events Maval", "Urbania for Office Trips Maval"],
    ["Best Urbania Rental Maval Pune", "Urbania Group Travel Maval"],
    ["Reliable Urbania Hire Maval Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Bus Hire in Maval",
        "WhyChoosedescription": "Urbania Bus Hire in Maval is perfect for group travel, corporate trips, school or college outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Bus Hire in Maval provides well-maintained Force Urbania buses with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Bus Hire in Maval comes with skilled and courteous drivers familiar with Maval routes, Pune highways, and nearby regions, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania Bus Hire in Maval for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Bus Hire in Maval provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Bus Hire in Maval is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania Bus Hire in Maval are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Bus Hire in Maval guarantees on-time pickups and dependable service for stress-free group travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Bus Hire in Maval available for local and outstation travel?',
        answer: 'Yes, Urbania Bus Hire in Maval can be booked for city travel, corporate trips, school or college outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania Bus Hire in Maval?',
        answer: 'You can book Urbania Bus Hire in Maval via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania Bus Hire in Maval?',
        answer: 'Urbania Bus Hire in Maval offers spacious seating, professional drivers, clean vehicles, and transparent pricing for group, corporate, and family travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania Bus Hire in Maval are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania Bus Hire in Maval allows flexible pickup and drop locations across Maval, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania Bus Hire in Maval available 24x7?',
        answer: 'Yes, Urbania Bus Hire in Maval operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania buses are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania Bus Hire in Maval accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania buses be used for corporate, school, or wedding trips?',
        answer: 'Yes, Urbania Bus Hire in Maval is ideal for corporate travel, school or college outings, wedding transportation, and group tours.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil More',
        feedback: 'Urbania Bus Hire in Maval provided excellent service for our school trip. Spacious, clean, and very punctual.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Patil',
        feedback: 'We hired Urbania Bus Hire in Maval for a corporate outing. Comfortable vehicle and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rohan Jadhav',
        feedback: 'Urbania Bus Hire in Maval made our wedding guest transport very smooth and hassle-free. Highly recommended.',
        rating: 5,
    },
];

















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus Hire in Maval",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-maval-pune.jpg",
  "description": "Urbania Bus Hire in Maval offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Maval and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-hire-maval"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus Hire in Maval | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus Hire in Maval for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Maval Pune."
  />

  <meta
    name="keywords"
    content="Urbania Bus Hire in Maval, Maval Urbania on Rent, Urbania Rental Service Maval Pune, Urbania AC Bus Hire Maval, Corporate Urbania Hire Maval, Urbania for Outstation Maval Pune, Urbania Airport Transfer Maval, Luxury Urbania Maval, Affordable Urbania Hire Maval, Chauffeur Driven Urbania Maval, Urbania for Wedding Events Maval, Urbania for Office Trips Maval, Best Urbania Rental Maval Pune, Urbania Group Travel Maval, Reliable Urbania Hire Maval Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaburhireinmaval;